import { useEffect, useRef, useState } from 'react';

import { usePosthogCapture } from 'shiftNotes/posthogCapture/shiftNotes';

const NO_AUDIO_WARNING_DELAY_MS = 5000;

interface UseNoAudioWarningOptions {
  isSpeaking: boolean;
  isPaused: boolean;
}

export default function useNoAudioWarning({
  isSpeaking,
  isPaused,
}: UseNoAudioWarningOptions): boolean {
  const shiftNotesCapture = usePosthogCapture();
  const [showNoAudioWarning, setShowNoAudioWarning] = useState(false);
  const lastAudioTimeRef = useRef<number>(Date.now());

  useEffect(() => {
    if (isSpeaking) lastAudioTimeRef.current = Date.now();
  }, [isSpeaking]);

  useEffect(() => {
    if (isPaused) {
      lastAudioTimeRef.current = Date.now();
      setShowNoAudioWarning(false);
      return () => {};
    }
    const interval = setInterval(() => {
      const elapsed = Date.now() - lastAudioTimeRef.current;
      const shouldShow = elapsed >= NO_AUDIO_WARNING_DELAY_MS;
      setShowNoAudioWarning((prev) => {
        if (shouldShow && !prev) {
          shiftNotesCapture.captureNoAudioWarningShown();
          return true;
        }
        if (!shouldShow && prev) return false;
        return prev;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [isPaused, shiftNotesCapture]);

  return showNoAudioWarning;
}
